// Auto-generated skeleton for CraftsmanTaskType

export const CraftsmanTaskType: Api.CraftsmanTaskType = {
  id: 0,
  hp_id: null,
  name: '',
  created: null,
  updated: null,
};

